"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = exports.metadata = void 0;
const { metadata } = require('./metadata');
exports.metadata = metadata;
const mainnet = require('./mainnet');
const staging = require('./staging');
const kovan = require('./kovan');
const goerli = require('./goerli');
const addresses = {
    mainnet: mainnet.addresses,
    staging: staging.addresses,
    kovan: kovan.addresses,
    goerli: goerli.addresses
};
const chains = {
    mainnet: mainnet.chains,
    staging: staging.chains,
    kovan: kovan.chains,
    goerli: goerli.chains
};
const bonders = {
    mainnet: mainnet.bonders,
    staging: staging.bonders,
    kovan: kovan.bonders,
    goerli: goerli.bonders
};
const config = {
    addresses,
    chains,
    bonders
};
exports.config = config;
